<template>
    <div class="vm-album-door flex-box flex-wrap" :class="[browser_size]">
        <template v-for="(item, i) in album_list">
            <router-link
                class="item block relative"
                v-if="i <= max - 1"
                :key="i"
                :to="`/album/${item.album_id}`"
                :target="GL.ENV.is_afd_client ? false : '_blank'"
            >
                <div
                    class="inner-box darkbg"
                    :style="{backgroundImage:`url(${$img_src({src:item.cover,width:320,height:320, is_show_origin: white_list.ORIGIN_ALBUM_IMG_USERS.indexOf(item.user_id) != -1 })})`}"
                >
                    <!-- <pic v-if="item.cover" class="self-center" :src="item.cover" width="320" height="320" /> -->
                </div>
                <div class="mt16 tit gl-hover-text-purple">{{item.title}}</div>
                <div v-if="item.update_time > 0" class="mt8 black-3 fs14">
                    <span v-text="$time_show(item.update_time)"></span>{{$t('c.AlbumDoor.text1')}}
                </div>
                <div v-if="item.bought == 1" class="bought-tag fs12 lh1">{{$t('c.AlbumDoor.text2')}}</div>
            </router-link>
        </template>
        <router-link
            v-if="has_create_btn && album_list.length < max"
            class="item"
            :to="`/edit/album`"
        >
            <div class="inner-box">
                <i class="afd afd-plus self-center"></i>
            </div>
        </router-link>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    album_list: {
      type: Array,
      default: []
    },
    max: {
      type: Number,
      default: 999999999
    },
    has_create_btn: {
      default: false
    }
  },
  data() {
    return {
      //   n: this.browser_size == "small" ? 2 : 3
    };
  },
  computed: {
    ...mapState("app", ["white_list"]),
    n() {
      return this.browser_size == "small" ? 2 : 3;
    }
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="stylus" scoped>
.vm-album-door {
    .inner-box {
        box-shadow: $layer-shadow;
    }
    .bought-tag{
        position absolute;
        right:16px;
        top:16px;
        padding:3px 6px;
        color:$white;
        border-radius:3px;
        background $forever;
    }

    &.small {
        padding: 0 16px;

        .tit {
            font-size: 16px;
        }

        .item {
            width: calc(50% - 8px);
            margin-bottom: 30px;

            &:nth-child(3n) {
                margin-right: 16px;
            }

            &:nth-child(2n) {
                margin-right: 0px;
            }

            &:nth-child(n+4) {
                margin-top: 0px;
            }
        }
    }

    .tit {
        font-size: 24px;
    }

    .item {
        flex-shrink: 0;
        height: auto;
        cursor: pointer;
        margin-right: 16px;
        width: calc(33.33% - 11px);

        // margin-bottom: 64px;
        &:nth-child(n+4) {
            margin-top: 64px;
        }

        &:nth-child(3n) {
            margin-right: 0px;
        }

        &:hover {
            .inner-box {
                background-color: rgba(234, 234, 234, 0.8);
            }
        }

        .inner-box {
            // background: rgba(234, 234, 234, 1);
            background: #FAFAFA;
            padding-bottom: 100%;
            position: relative;
            height: auto;
            border-radius: 8px;
            background-size: cover;

            img {
                border-radius: 8px;
            }
        }

        i {
            color: $black-1;
            font-size: 60px;
        }
    }
}
</style>
